import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserFuntionService } from '@ascschool/services/user/user-funtion.service';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzFormatEmitEvent, NzTreeComponent, NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { element } from 'protractor';

@Component({
  selector: 'app-select-tree',
  templateUrl: './select-tree.component.html',
  styleUrls: ['./select-tree.component.scss']
})
export class SelectTreeComponent implements OnInit {
  @ViewChild('nzTreeComponent', { static: false }) nzTreeComponent: NzTreeComponent;
  @Input() value: number[];
  listKeyChecked: string[] = [];
  nodes: any;
  type: any = 1;
  validateForm: FormGroup;
  listOfOption: any = [];
  listCheck: any =[];
  constructor(
    private modal: NzModalRef,
    private service: UserFuntionService,
  ) { }

  ngOnInit() {
    this.listOfOption = [{
      label : 'Chọn theo',
      value : 1,
    }];
    this.initializationValues();
  }
  close(e: MouseEvent) {
    e.preventDefault();
    this.modal.destroy(false);
  }
  nzClick(event: NzFormatEmitEvent): void{
    if(event.node.children.length > 0){      
      event.node.children.forEach(element => {
        element.setChecked(!event.node.isChecked);
      });
      event.node.setChecked(!event.node.isChecked);
    }else{
      event.node.setChecked(!event.node.isChecked);
      if(!event.node.isChecked){
        event.node.getParentNode().setChecked(event.node.isChecked, true);
      }
    }
  }
  checkElementHasChild(element: NzTreeNode){
    if(element.children.length === 0){
      this.listCheck.push(element);
    }else{
      element.children.forEach(element_2 =>{
        this.checkElementHasChild(element_2);
      });
    }
  }
  initializationValues() {
    this.service.getTreeGroupByUser().subscribe((resp) => {
      this.nodes = resp;
      if(this.value.length > 0){
        this.listKeyChecked = [];
        resp.forEach(element => {
          this.value.forEach(ckeckedId=>{
            this.checkKeyId(element, ckeckedId);
          });
        });
      }
    });
  }
  checkKeyId(element, checkedId){
    if(element.children === null){
      if(element.id === checkedId){
        this.listKeyChecked.push(element.key);
      }
    }else{
      element.children.forEach(element_2 => {
        this.checkKeyId(element_2, checkedId);
      });
    }
  }
  submit(){
    this.listCheck = [];
    let listIdChecked = [];
    let checkedList = this.nzTreeComponent.getCheckedNodeList();
    checkedList.forEach(element =>{
      this.checkElementHasChild(element);
    });
    this.listCheck.forEach(element => {
      listIdChecked.push(element.origin.id);
    });
    this.modal.destroy(listIdChecked);
  }
}
